const accordionInstance = {
    Init: function (accordion) {
        new Vue({
            el: accordion
        });
    },
};